/**
 * Medication Scan Types
 * Типы для модуля "Медикаменты" - сканирование препаратов
 */

/**
 * Статусы синхронизации с 1С
 */
export enum SyncStatus {
  PENDING = 'pending',
  SYNCED = 'synced',
  FAILED = 'failed',
}

/**
 * Основная модель сканирования препарата
 */
export interface MedicationScan {
  id: string;
  tenant_id: string;
  employee_id: string;
  employee_name: string; // ФИО сотрудника
  gtin: string; // 14 цифр
  serial_number: string;
  unique_identifier?: string; // GTIN + SerialNumber
  country_code?: string; // ISO 3166-1 alpha-2
  crypto_signature?: string;
  batch_number?: string;
  expiry_date?: string; // YYYY-MM-DD
  patient_iin?: string; // 12 цифр
  notes?: string;
  scanned_at: string; // ISO 8601 UTC
  created_at: string;
  updated_at: string;
  sync_status: SyncStatus; // Статус синхронизации с 1С
  sync_error?: string; // Текст ошибки (только для failed)
  synced_at?: string; // ISO 8601 UTC timestamp
}

/**
 * Фильтры для поиска и фильтрации сканирований
 */
export interface MedicationScanFilters {
  gtin?: string; // Поиск по GTIN (14 цифр)
  employee_id?: string; // Фильтр по сотруднику
  patient_iin?: string; // Фильтр по ИИН пациента (12 цифр)
  from?: string; // Дата начала (YYYY-MM-DD)
  to?: string; // Дата окончания (YYYY-MM-DD)
  sync_status?: string; // Фильтр по статусу синхронизации
  page?: number; // Номер страницы (default: 1)
  page_size?: number; // Размер страницы (default: 20, max: 100)
  sort?: string; // Сортировка (default: 'scanned_at:desc')
}

/**
 * Метаданные пагинации
 */
export interface PaginationMeta {
  page: number;
  page_size: number;
  total_items: number;
  total_pages: number;
  has_next: boolean;
  has_previous: boolean;
}

/**
 * Ответ API с пагинацией для сканирований
 */
export interface PaginatedMedicationScansResponse {
  scans: MedicationScan[];
  pagination: PaginationMeta;
}

/**
 * Статистика по сканированиям
 */
export interface MedicationStatistics {
  total_scans: number; // Всего сканирований
  unique_medications: number; // Уникальных препаратов (по GTIN)
  scans_today: number; // Сканирований сегодня
  unique_patients: number; // Уникальных пациентов (по ИИН)
}

/**
 * DTO для создания сканирования (если потребуется)
 */
export interface CreateMedicationScanDto {
  gtin: string;
  serial_number: string;
  unique_identifier?: string;
  country_code?: string;
  crypto_signature?: string;
  batch_number?: string;
  expiry_date?: string;
  patient_iin?: string;
  scanned_at: string;
  notes?: string;
}
